'use client'

import React, { FC } from 'react'
import { SnipeShield } from '@/components/secure-listing-badge'

/** The green shield + "On" shown as the value of a "Snipe protection" invoice row. */
export const SnipeProtectionOn: FC = () => <SnipeShield label="On" />

/**
 * One invoice-style line on the single-item sell drawer, which has no
 * Invoice component. Not a control: protection is on whenever the API
 * offers it, and the bulk sell forms show the same fact as an Invoice row.
 */
const SnipeProtectionRow: FC<{ offered: boolean }> = ({ offered }) => {
	if (!offered) {
		return null
	}
	return (
		<div className="flex items-center justify-between text-xs text-muted-foreground" data-testid="snipe-protection-row">
			<span>Snipe protection</span>
			<SnipeProtectionOn />
		</div>
	)
}

export default SnipeProtectionRow

/** The Invoice item the sell forms and buy invoices append when protection is on. */
export function snipeProtectionInvoiceItem(on: boolean): Array<{ title: string; value: React.ReactNode }> {
	return on ? [{ title: 'Snipe protection', value: <SnipeProtectionOn /> }] : []
}
